import React from "react";
import { SiteContext } from "../contexts/SiteContext";
import { Link } from "react-router-dom";
import { Tooltip, makeStyles, Typography, Divider } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";

const useStyles = makeStyles((theme) => ({
	datagrid: {
		"& a": {
			textDecoration: "none",
			color: theme.palette.primary.main,
		},
		"& a:visited": {
			textDecoration: "none",
			color: theme.palette.primary.main,
		},
		"& a:hover": {
			textDecoration: "underline",
		},
		//Remove outlines when clicking a cell in the datagrid
		"&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
			outline: 0,
		},
		//Remove outlines when clicking a column header
		"&.MuiDataGrid-root .MuiDataGrid-colCell:focus": {
			outline: 0,
		},
	},
}));

function Related({ entries }) {
	const { selectedSite, setSelectedSite } = React.useContext(SiteContext);
	const classes = useStyles();
	const [sortModel, setSortModel] = React.useState([
		{
			field: "title",
			sort: "asc",
		},
	]);
	const [pageSize, setPageSize] = React.useState(5);
	const columns = React.useMemo(
		() => [
			{
				field: "title",
				headerName: "Entry Title",
				flex: 1,
				renderCell: (params) => {
					return (
						<Tooltip title={params.row.title} placement="bottom-start">
							<Link to={`/${selectedSite.slug}/entries/${params.row.slug}`}>
								{params.row.title}
							</Link>
						</Tooltip>
					);
				},
			},
		],
		[selectedSite]
	);

	return (
		<>
			<Divider variant="middle" />
			<Typography
				style={{ marginTop: "1rem" }}
				gutterBottom
				component="h2"
				variant="h6"
			>
				Related Entries
			</Typography>
			<DataGrid
				pageSize={pageSize}
				onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
				rowsPerPageOptions={[5, 10, 25]}
				pagination
				className={classes.datagrid}
				getRowId={(row) => row._id}
				autoHeight
				rows={entries}
				columns={columns}
				sortModel={sortModel}
				onSortModelChange={(model) => setSortModel(model)}
				disableSelectionOnClick
			/>
		</>
	);
}

export default Related;
